import {
    ChangeDetectionStrategy,
    Component,
    Injectable,
} from '@angular/core';
import {
    CredentialStoreResourceType,
    ICredentialStore,
    ICredentialStoreResource,
    ODataResponse,
} from '@models';
import {
    GRID_SERVICE,
    IGridSource,
    ODataGridComponent,
} from '@pages/generics/grid';
import {
    CredentialStoresService,
    ODataQueryOptions,
} from '@services';

@Injectable({
    providedIn: 'root',
})
export class RobotCredentialStoreResourcesSource implements IGridSource<ODataQueryOptions, ODataResponse<ICredentialStoreResource>> {
    public credentialStore!: ICredentialStore;
    public totalRobots?: number;

    public get mapper() {
        return this._credentialStore.mapper;
    }

    constructor(
        private _credentialStore: CredentialStoresService,
    ) { }

    public get(qo?: ODataQueryOptions) {
        return this._credentialStore.getResourcesForCredentialStore(
                this.credentialStore,
                CredentialStoreResourceType.RobotCredential,
                qo);
    }
}

@Component({
    selector: 'ui-robot-credential-store-resources-grid',
    templateUrl: './credential-store-resources.grid.html',
    providers: [{
        provide: GRID_SERVICE,
        useExisting: RobotCredentialStoreResourcesSource,
        deps: [
            CredentialStoresService,
        ],
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RobotCredentialStoreResourcesComponent
    extends ODataGridComponent<ICredentialStoreResource, number> { }
